import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children, allowedRoles }) {
    const userData = JSON.parse(localStorage.getItem('user'));

    if (!userData || !userData.role || !userData.token) {
        return <Navigate to="/login" replace />;
    }

    if (allowedRoles && !allowedRoles.includes(userData.role)) {
        return <Navigate to="/" replace />;
    }

    return children;
}
